export const ADD_ORGANIZATIONS_REQUEST = 'ADD_ORGANIZATIONS_REQUEST'
export const ADD_ORGANIZATIONS_SUCCESS = 'ADD_ORGANIZATIONS_SUCCESS'
export const ADD_ORGANIZATIONS_FAILURE = 'ADD_ORGANIZATIONS_FAILURE'
export const ADD_ORGANIZATIONS_UPDATE = 'ADD_ORGANIZATIONS_UPDATE'

